export default "__VITE_ASSET__GvqprbiR__"